<template>
  <div class="program-select-day">
    <div v-if="!currentDay.day" class="day-duration">
      <el-select
         v-if="programDays"
         v-model="options.dayID"
        @change="changeSelectedDay">
        <el-option v-for="day in programDays" :label="$t('label.day_no', { value: day.day_number })" :value="day.id" :key="day.id"></el-option>
      </el-select>
    </div>
    <div v-if="currentDay.day" class="date-picker">
      <el-date-picker
         v-model="options.day"
         type="date"
         format="dd/MM/yyyy"
         value-format="yyyy-MM-dd"
        :editable="false"
        :clearable="false"
        :picker-options="{ firstDayOfWeek: 1, disabledDate: checkDateDisabled }"
        @change="changeSelectedDayFromDatePicker">
      </el-date-picker>
    </div>
  </div>
</template>
        <!-- format="Do, MMMM yyyy" -->

<script>
import moment from 'moment';
import { find, clone } from 'lodash';

export default {
  name: 'cmpt-program-select-day',
  props: {
    id: {
      required: true,
      default: null,
    },
    dayID: {
      required: true,
      default: null,
    },
    programDays: {
      type: Array,
      required: true,
    },
    startDate: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      options: {
        day: null,
        dayID: null,
      },
    };
  },
  methods: {
    changeSelectedDay(dayID) {
      this.$emit('update:dayID', dayID);
    },
    changeSelectedDayFromDatePicker(date) {
      const day = find(this.programDays, item => item.day === date);
      if (day) this.$emit('update:dayID', day.id);
    },
    checkDateDisabled(date) {
      return !this.findCurrentDayByDate(date);
    },
    findCurrentDayByID(dayID) {
      return find(this.programDays, item => Number(item.id) === Number(dayID));
    },
    findCurrentDayByDate(date) {
      const compare = moment(date).format('YYYY-MM-DD');
      return find(this.programDays, item => item.day === compare);
    },
    findAndUpdateCurrentDayByID() {
      const current = this.findCurrentDayByID(this.dayID);
      this.options.day = clone(current.day);
    },
  },
  computed: {
    currentDay() {
      return this.findCurrentDayByID(this.dayID);
    },
  },
  watch: {
    programDays() {
      this.findAndUpdateCurrentDayByID();
    },
    dayID(value) {
      this.findAndUpdateCurrentDayByID();
      this.options.dayID = value;
    },
  },
  created() {
    this.findAndUpdateCurrentDayByID();
    this.options.dayID = this.dayID;
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .program-select-day {
    padding: 0.65em 0 0 0.65em;
    text-align: center;
    display: inline-block;
    width: 100%;
    .date-picker, .day-duration {
      display: inline-block;
      padding-right: 0.65em;
      padding-bottom: 0.75em;
      width: 100%;
      .el-date-editor.el-input, .el-select {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/list/cmpt-program-select-day.vue